import * as React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import LibraryBooksIcon from '@mui/icons-material/AutoStories';
import { Link, useParams } from "react-router-dom";
import { Search } from '@mui/icons-material';

export default function AutoCompleteSwarWith3Digits() {
  const [direction ,setdirection]=React.useState();
  let pars = useParams();
  let idsh = pars.id;
  idsh-=1;
  let quraaIds = {
    'الفاتحه':"001",
    "البقرة" :"002" , 
    'آل عمران' :"003",
    'النساء':"004" ,
    "المائدة":"005" ,
    'الأنعام' :"006",
    'الأعراف' :"007",
    "الأنفال" :"008",
    "التوبة" :"009",
    'يونس' :"010",
    'هود' :"011",
    "يوسف" :"012",
    'الرعد' :"013",
    'إبراهيم' :"014",
    'الحجر' :"015",
    "النحل" :"016",
    'الإسراء' :"017",
    'الكهف' :"018",
    "مريم" :"019",
    "طه" :"020",
    'الأنبياء' :"021",
    'الحج':"022" ,
    "المؤمنون":"023" ,
    'النور' :"024",
    'الفرقان' :"025",
    'الشعراء' :"026",
    'النمل' :"027",
    "القصص" :"028",
    'العنكبوت' :"029",
    'الروم' :"030",
    'لقمان' :"031",
    "السجدة":"032" ,
    'الأحزاب' :"033",
    'سبأ' :"034",
    "فاطر" :"035",
    "يس" :"036",
    'الصافات':"037" ,
    'سورة ص' :"038",
    "الزمر" :"039",
    'غافر' :"040",
    'فصلت' :"041",
    'الشورى' :"042",
    "الزخرف" :"043",
    'الدخان' :"044",
    'الجاثية' :"045",
    'الأحقاف' :"046",
    'محمد' :"047",
    "الفتح" :"048",
    'الحجرات' :"049",
    'سورة ق' :"050",
    'الذاريات' :"051",
    "الطور" :"052",
    'النجم': "053",
    'القمر':"054" ,
    "الرحمن" :"055",
    "الواقعة" :"056",
    'الحديد' :"057",
    'المجادلة' :"058",
    "الحشر" :"059",
    'الممتحنة' :"060",
    'الصف' :"061",
    "الجمعة" :"062",
    "المنافقون" :"063",
    'التغابن' :"064",
    'الطلاق' :"065",
    "التحريم" :"066",
    'الملك' :"067",
    'القلم' :"068",
    "الحاقة" :"069",
    "المعارج" :"070",
    'نوح' :"071",
    'الجن' :"072",
    "المزمل" :"073",
    'المدثر' :"074",
    'القيامة' :"075",
    'الإنسان' :"076",
    "المرسلات" :"077",
    'النبأ' :"078",
    'النازعات' :"079",
    "عبس" :"080",
    "التكوير" :"081",
    'الإنفطار' :"082",
    'المطففين' :"083",
    "الانشقاق" :"084",
    'البروج' :"085",
    'الطارق' :"086",
    'الأعلى' :"087",
    'الغاشية' :"088",
    "الفجر" :"089",
    'البلد' :"090",
    'الشمس' :"091",
    'الليل' :"092",
    "الضحى" :"093",
    'الشرح' :"094",
    'التين' :"095",
    "العلق" :"096",
    "القدر" :"097",
    'البينة' :"098",
    'الزلزلة' :"099",
    "العاديات" :"100",
    'القارعة' :"101",
    'التكاثر' :"102", 
    'العصر' :"103",
    "الهمزة" :"104",
    'الفيل' :"105",
    'قريش' :"106",
    'الماعون':"107" ,
    'الكوثر' :"108",
    "الكافرون" :"109",
    'النصر' :"110",
    'المسد' :"111",
    'الإخلاص' :"112",
    "الفلق" :"113",
    'الناس' :"114",
    
  };
  

  const top100Films = [
        {label: "الفاتحة" },
        {label: "البقرة" },
        {label: 'آل عمران' },
        {label: 'النساء' },
        {label: "المائدة" },
        {label: 'الأنعام' },
        {label: 'الأعراف' },
        {label: "الأنفال" },
        {label: "التوبة" },
        {label: 'يونس' },
        {label: 'هود' },
        {label: "يوسف" },
        {label: 'الرعد' },
        {label: 'إبراهيم' },
        {label: 'الحجر' },
        {label: "النحل" },
        {label: 'الإسراء' },
        {label: 'الكهف' },
        {label: "مريم" },
        {label: "طه" },
        {label: 'الأنبياء' },
        {label: 'الحج' },
        {label: "المؤمنون" },
        {label: 'النور' },
        {label: 'الفرقان' },
        {label: 'الشعراء' },
        {label: 'النمل' },
        {label: "القصص" },
        {label: 'العنكبوت' },
        {label: 'الروم' },
        {label: 'لقمان' },
        {label: "السجدة" },
        {label: 'الأحزاب' },
        {label: 'سبأ' },
        {label: "فاطر" },
        {label: "يس" },
        {label: 'الصافات' },
        {label: 'سورة ص' },
        {label: "الزمر" },
        {label: 'غافر' },
        {label: 'فصلت' },
        {label: 'الشورى' },
        {label: "الزخرف" },
        {label: 'الدخان' },
        {label: 'الجاثية' },
        {label: 'الأحقاف' },
        {label: 'محمد' },
        {label: "الفتح" },
        {label: 'الحجرات' },
        {label: 'سورة ق' },
        {label: 'الذاريات' },
        {label: "الطور" },
        {label: 'النجم' },
        {label: 'القمر' },
        {label: "الرحمن" },
        {label: "الواقعة" },
        {label: 'الحديد' },
        {label: 'المجادلة' },
        {label: "الحشر" },
        {label: 'الممتحنة' },
        {label: 'الصف' },
        {label: "الجمعة" },
        {label: "المنافقون" },
        {label: 'التغابن' },
        {label: 'الطلاق' },
        {label: "التحريم" },
        {label: 'الملك' },
        {label: 'القلم' },
        {label: "الحاقة" },
        {label: "المعارج" },
        {label: 'نوح' },
        {label: 'الجن' },
        {label: "المزمل" },
        {label: 'المدثر' },
        {label: 'القيامة' },
        {label: 'الإنسان' },
        {label: "المرسلات" },
        {label: 'النبأ' },
        {label: 'النازعات' },
        {label: "عبس" },
        {label: "التكوير" },
        {label: 'الإنفطار' },
        {label: 'المطففين' },
        {label: "الانشقاق" },
        {label: 'البروج' },
        {label: 'الطارق' },
        {label: 'الأعلى' },
        {label: 'الغاشية' },
        {label: "الفجر" },
        {label: 'البلد' },
        {label: 'الشمس' },
        {label: 'الليل' },
        {label: "الضحى" },
        {label: 'الشرح' },
        {label: 'التين' },
        {label: "العلق" },
        {label: "القدر" },
        {label: 'البينة' },
        {label: 'الزلزلة' },
        { label: "العاديات" },
        { label: 'القارعة' },
        { label: 'التكاثر' },
        { label: 'العصر' },
        { label: "الهمزة" },
        { label: 'الفيل' },
        { label: 'قريش' },
        { label: 'الماعون' },
        { label: 'الكوثر' },
        { label: "الكافرون" },
        { label: 'النصر' },
        { label: 'المسد' },
        { label: 'الإخلاص' },
        { label: "الفلق" },
        { label: 'الناس' },  ];

  function selectFun(e){
    let target=e.target.value;
    let id=quraaIds[target]
    if(id){
    setdirection(`/${idsh}/${id}`)
  }
  }

  return (
    <Autocomplete
    sx={{ marginTop: '-20px',marginBottom:'30px' ,border:"1px solid white" }}
      freeSolo
      options={top100Films.map((option) => option.label)}
      renderInput={(params) => (
        
        <TextField
          {...params}
          placeholder="أدخل أسم السورة"
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <LibraryBooksIcon style={{ color: 'white' }} />
            ),
            endAdornment:(
              <Link to={direction}> <Search style={{cursor:"pointer", color:"white" , margin:"5px",borderRadius:"10px"}} /></Link>
            ),
            style: { color: 'white' }
          }}
        />
      )}
      onSelect={selectFun}
      ListboxProps={{
        style: { background: '#27292f', color: 'white' ,fontFamily:"Noto Nastaliq Urdu"}
      }}
      
    />
  );
}